module.exports = __webpack_public_path__ + "img/97Ox9O.d41d8cd9.svg";